import { useMutation, useQuery } from "react-query";
import * as analytics from "services/analytics/analytics";

/** Filter dropdowns change rarely, so they are cached for the session. */
export const useFilterOptions = () =>
  useQuery("analyticsFilterOptions", analytics.FilterOptions, {
    refetchOnWindowFocus: false,
    staleTime: 5 * 60 * 1000,
  });

export const useManpowerTrend = () =>
  useMutation((filters) => analytics.ManpowerTrend(filters));

export const useContractorManpower = () =>
  useMutation((filters) => analytics.ContractorManpower(filters));

export const useSiteComparison = () =>
  useMutation((filters) => analytics.SiteComparison(filters));

export const useArrivalPattern = () =>
  useMutation((filters) => analytics.ArrivalPattern(filters));

export const useAttendanceSummary = () =>
  useMutation((filters) => analytics.AttendanceSummary(filters));

export const useMonthlyAttendance = () =>
  useMutation((filters) => analytics.MonthlyAttendance(filters));

export const useManpowerForecast = (horizonDays = 14) =>
  useQuery(
    ["manpowerForecast", horizonDays],
    () => analytics.ManpowerForecast(horizonDays),
    { refetchOnWindowFocus: false, staleTime: 10 * 60 * 1000 }
  );
